import Vue from "vue";
import conf from "@/assets/conf/setting.json";
import { getUserAgentInfo } from "@/common/utils.js";
import service from "@/service";
import { SExtraFilter } from "../stempcore/src/core/sextra";
import "@/assets/scss/index.scss";

window.$ua = getUserAgentInfo();
import "normalize.css";
import "@/plugins/antdv.js";
import "@/plugins/vant.js";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

Vue.prototype.$conf = conf;
Vue.use(SExtraFilter);

Vue.mixin({
  methods: {
    pxOrVw(value) {
      if (!value) return "";
      let newValue;
      if (window.$ua.isMobile) {
        if (value > 2) {
          newValue = value / 7.5 + "vw";
        } else {
          newValue = "1px";
        }
      } else {
        newValue = value + "px";
      }
      return newValue;
    }
  }
});

Vue.use(service);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
